import { BigNumber } from '@ethersproject/bignumber'
import { Currency, CurrencyAmount } from '@uniswap/sdk-core'
import { Pool } from '@uniswap/v3-sdk'
import { useV3PositionFees } from 'hooks/useV3PositionFees'
import { useEffect, useRef } from 'react'

export interface PositionFeesData {
  tokenId: string
  fee0: CurrencyAmount<Currency> | undefined
  fee1: CurrencyAmount<Currency> | undefined
}

interface PositionFeesFetcherProps {
  pool: Pool | undefined | null
  tokenId: BigNumber
  onFeesLoaded: (data: PositionFeesData) => void
}

/**
 * Invisible component that fetches unclaimed fees for a single position
 * and reports the result to its parent via callback.
 */
export function PositionFeesFetcher({ pool, tokenId, onFeesLoaded }: PositionFeesFetcherProps) {
  const [fee0, fee1] = useV3PositionFees(pool ?? undefined, tokenId)
  const prevKey = useRef<string>('')

  useEffect(() => {
    const key = `${tokenId.toString()}-${fee0?.toExact()}-${fee1?.toExact()}`
    if (key !== prevKey.current) {
      prevKey.current = key
      onFeesLoaded({
        tokenId: tokenId.toString(),
        fee0,
        fee1,
      })
    }
  }, [fee0, fee1, tokenId, onFeesLoaded])

  return null
}
